import { AuthHeader, TOKEN, TOKEN_EXPIRES_AT, REFRESH_TOKEN } from './authheader';
import cookie from 'js-cookie';
import { message } from 'antd';

export const API_URL = process.env.API_URL || process.env.REACT_APP_API_URL;
const USER_INFO = 'userInfo';

class APIService {
  
	async doPublicRequest(url, method, data)
	{
		try {
			if(method === 'GET' && data){
				const queryParams = new URLSearchParams();
	            for (const key in data) {
	                if (data.hasOwnProperty(key)) {
	                    queryParams.append(key, data[key]);
	                }
	            }
	            url += '?' + queryParams.toString();
				data = null;
			}
		    const response = await this.fetchWithTimeout(`${API_URL}/${url}`, {
		      method: method,
		      body: data ? JSON.stringify(data) : null,
		      headers: {'Content-Type': 'application/json'},
		    }, 500 * 1000);
		
			return this.handleResponse(response);
		  } catch (error) {
		    console.error('Fetch error:', error);
		  }
	}

	async doRequest(url, method, data, headers=null, options=null)
	{
		console.log(url);
		if (this.isTokenExpired()) {
			message.error('Session expired. Redirecting to login...');
			this.handleLogout();
			return;
		}

		try {
			if(method === 'GET' && data){
				const queryParams = new URLSearchParams();
				for (const key in data) {
					if (data.hasOwnProperty(key)) {
						queryParams.append(key, data[key]);
					}
				}
				url += '?' + queryParams.toString();
				data = null;
			}
			
			const requestOptions = {
				method: method,
				...options || {},
			};
			
			if (data && data instanceof FormData) {
				requestOptions.body = data;
				const authHeaders = AuthHeader(headers);
				const { 'Content-Type': _, ...filteredHeaders } = authHeaders;
				requestOptions.headers = filteredHeaders;
			} else {
				requestOptions.body = data ? JSON.stringify(data) : null;
				requestOptions.headers = AuthHeader(headers);
			}
			
			const response = await this.fetchWithTimeout(`${API_URL}/${url}`, requestOptions, 500 * 1000);
		
			return this.handleResponse(response);
		} catch (error) {
			console.error('Fetch error:', error);
		}
	}
	
	async doUploadRequest(url, file, headers=null, options=null)
	{		
		try {
			
			const formData = new FormData();
			formData.append('file', file);
			
			const authHeaders = AuthHeader(headers);
		    const { 'Content-Type': _, ...filteredHeaders } = authHeaders;
      
		    const response = await fetch(`${API_URL}/${url}`, {
		      method: 'POST',
		      body: formData,
		      headers: filteredHeaders ,
		      ...options || {},
		    });
		
			return this.handleResponse(response);
		  } catch (error) {
		    console.error('Fetch error:', error);		    
		  }
	}
	
	async doExportRequest(url, filters, headers=null, options=null)
	{
		return this.doRequest(url, 'GET', filters, headers, options);
	}
	
	async handleResponse(response) 
	{
		try {

			if (!response.ok) {
				let errorData;
				try {
					errorData = await response.json();
				} catch (jsonError) {
					throw new Error(`Unexpected error: ${response.statusText}`);
				}

				console.error('Error details:', errorData);

				if (response.status === 401 || response.status === 419) {
					//message.error(errorData.message);
					this.handleLogout();
					throw new Error(`Error: ${errorData.message}`);
					// return;
				}

				if(errorData.errors){	    
					const errorObject = {};
					for (const [field, messages] of Object.entries(errorData.errors)) {
						errorObject[field] = messages.join(' ');
					}
					console.log(errorObject);
					return {errorMessage: errorObject}; 
				}else{
					message.error(`Error: ${errorData.message}`);
					throw new Error(`Error: ${errorData.message}`);
				}
			}
		
			const responseData = await response.json();
			console.log('Data received:', responseData);
			return responseData;
		} catch (error) {
			// console.error('Request failed:', error);
			//message.error('Request failed');
			throw error;
		}
  	}
  	
  	async fetchWithTimeout(url, options = {}, timeout = 30000)
  	{
	  const controller = new AbortController();
	  const signal = controller.signal;
	  
	  const timeoutId = setTimeout(() => controller.abort(), timeout);
	
	  try {
	    const response = await fetch(url, { ...options, signal });
	    clearTimeout(timeoutId);
	    return response;
	  } catch (error) {
	    if (error.name === 'AbortError') {
	      throw new Error('Request timed out');
	    }
	    throw error;
	  }
	};
	
	setToken(token){
		cookie.set(TOKEN, token);
	}
	
	getToken(){
		return cookie.get(TOKEN);
	}
	
	deleteToken(){
		cookie.remove(TOKEN);
	}

	setTokenExpiresAt(expires_in){
		cookie.set(TOKEN_EXPIRES_AT, Date.now() + expires_in * 1000);
	}

	getTokenExpiresAt(){
		return cookie.get(TOKEN_EXPIRES_AT);
	}

	deleteTokenExpiresAt(){
		cookie.remove(TOKEN_EXPIRES_AT);
	}

	isTokenExpired() {
		const expiresAt = this.getTokenExpiresAt();
		return !expiresAt || Date.now() >= parseInt(expiresAt, 10);
	}
	
	setRefreshToken(token){
		cookie.set(REFRESH_TOKEN, token);
	}
	
	getRefreshToken(){
		return cookie.get(REFRESH_TOKEN);
	}
	
	getUserInfo(){
	    const userInfo = cookie.get(USER_INFO);
	    if(userInfo){
	      return JSON.parse(userInfo);
	    }
	    return null;
  	}
  	
  	setUserInfo(userInfo){
		cookie.set(USER_INFO, userInfo);
	}
	
	deleteUserInfo(){
		cookie.remove(USER_INFO);
	}

	handleLogout(){
		this.deleteToken();
		this.deleteUserInfo();
		this.deleteTokenExpiresAt();
		localStorage.clear();
	}
	
}

const apiService = new APIService();

export default apiService;